import { daysOverdue } from './timezone';
export const AR_COLUMNS = [['invoice_number','Invoice #'],['customer_name','Customer'],['issue_date','Issue Date'],['due_date','Due Date'],['total','Amount'],['status','Status'],['aging','Aging']];
export function sortInvoices(rows, key, direction, now = new Date()) {
  if (!key) return rows;
  const value = row => {
    if (key === 'aging') { if (['paid','cancelled'].includes(row.status) || !row.due_date) return null; return daysOverdue(row.due_date, now); }
    if (key === 'issue_date' || key === 'due_date') { const t = row[key] ? +new Date(row[key]) : NaN; return Number.isFinite(t) ? t : null; }
    if (key === 'total') return row.total == null || !Number.isFinite(Number(row.total)) ? null : Number(row.total);
    return row[key] == null ? null : String(row[key]);
  };
  return rows.map((row,index)=>({row,index})).sort((a,b)=>{
    const av=value(a.row), bv=value(b.row);
    if (av == null || bv == null) return av == null && bv == null ? a.index-b.index : av == null ? 1 : -1;
    const cmp = typeof av === 'number' ? av-bv : av.localeCompare(bv,undefined,{numeric:true,sensitivity:'base'});
    return (direction === 'desc' ? -cmp : cmp) || a.index-b.index;
  }).map(x=>x.row);
}
export function toCSV(rows) {
  return rows.map(row=>row.map(value=>{
    let s=String(value ?? '');
    if (/^[\s\u0000-\u001f]*[=+@-]/.test(s)) s="'"+s;
    return '"'+s.replace(/"/g,'""')+'"';
  }).join(',')).join('\r\n');
}
